import { Component, Story, Knobs, Accents } from './DocTypes';

const PlaygroundKnobs: Knobs = {
  disabled: {
    default: false,
    editor: 'checkbox',
  },
  accent: {
    default: 'viridiangreen',
    editor: 'dropdown',
    editorOptions: Accents,
  },
};

const PlaygroundKnobsV3: Knobs = {
  ...PlaygroundKnobs,
  'colour-scheme': {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', 'default', ''],
    default: '',
  },
  device: {
    editor: 'dropdown',
    editorOptions: ['mobile', 'desktop', ''],
    default: '',
  },
};

const PlaygroundStory: Story = {
  title: 'Playground',
  description: 'A tag-toggle where you can change various attributes',
  coreComponent: {
    html: `<tag-toggle value='2'{{...knobs}}>
  <tag-edit-field-option value='0'>Option 0</tag-edit-field-option>
  <tag-edit-field-option value='1'>Option 1</tag-edit-field-option>
  <tag-edit-field-option value='2'>Option 2</tag-edit-field-option>
  <tag-edit-field-option value='3'>Option 3</tag-edit-field-option>
</tag-toggle>`,
    knobs: PlaygroundKnobs,
  },
  coreComponent_v3: {
    html: `<tag3-toggle value='2'{{...knobs}}>
  <tag3-toggle-option value='0'>Option 0</tag3-toggle-option>
  <tag3-toggle-option value='1'>Option 1</tag3-toggle-option>
  <tag3-toggle-option value='2'>Option 2</tag3-toggle-option>
  <tag3-toggle-option value='3'>Option 3</tag3-toggle-option>
</tag3-toggle>`,
    knobs: PlaygroundKnobsV3,
  },
  reactWrapper: {
    jsx: `<TagToggle{{...knobs}}
  value='2'
  data={[
    { label: 'Option 0', value: 0 },
    { label: 'Option 1', value: 1 },
    { label: 'Option 2', value: 2 },
    { label: 'Option 3', value: 3 },
  ]}
/>`,
    knobs: PlaygroundKnobs,
  },
  reactWrapper_v3: {
    jsx: `<Tag3Toggle value='2'{{...knobs}}>
      <Tag3ToggleOption value='0'>Option 0</Tag3ToggleOption>
      <Tag3ToggleOption value='1'>Option 1</Tag3ToggleOption>
      <Tag3ToggleOption value='2'>Option 2</Tag3ToggleOption>
      <Tag3ToggleOption value='3'>Option 3</Tag3ToggleOption>
    </Tag3Toggle>`,
    knobs: PlaygroundKnobsV3,
  },
};

const DataStory: Story = {
  title: 'Data',
  description:
    'The options can be specified via a data prop as an alternative to using options component',
  coreComponent: {
    html: `<tag-toggle>
</tag-toggle>`,
    js: `var tagToggle = document.querySelector('tag-toggle');
tagToggle.componentOnReady().then(function() {
  tagToggle.data = [
    { label: 'Option 0', value: 0 },
    { label: 'Option 1', value: 1 },
    { label: 'Option 2', value: 2 },
    { label: 'Option 3', value: 3 },
  ];
  tagToggle.value = '2';
});`,
  },
  coreComponent_v3: {
    html: `<tag3-toggle>
    </tag3-toggle>`,
    js: `var tagToggle = document.querySelector('tag3-toggle');
    tagToggle.data = [
      { label: 'Option 0', value: 0 },
      { label: 'Option 1', value: 1 },
      { label: 'Option 2', value: 2 },
      { label: 'Option 3', value: 3 },
    ];
    tagToggle.value = '2';
  `,
  },
  reactWrapper: {
    jsx: `<TagToggle
    value={2}
    data={[
      { label: 'Option 0', value: 0 },
      { label: 'Option 1', value: 1 },
      { label: 'Option 2', value: 2 },
      { label: 'Option 3', value: 3 },
    ]}
  />`,
  },
  reactWrapper_v3: {
    jsx: `<Tag3Toggle
    value={2}
    data={[
      { label: 'Option 0', value: 0 },
      { label: 'Option 1', value: 1 },
      { label: 'Option 2', value: 2 },
      { label: 'Option 3', value: 3 },
    ]}
  />`,
  },
};

const FocusStory: Story = {
  title: 'Focus',
  description: 'Set focus on the toggle',
  coreComponent: {
    html: `<tag-toggle value='2'>
    <tag-edit-field-option value='1'>Option 1</tag-edit-field-option>
    <tag-edit-field-option value='2'>Option 2</tag-edit-field-option>
    <tag-edit-field-option value='3'>Option 3</tag-edit-field-option>
  </tag-toggle>
  <div style='margin-top: 10px'>
    <tag-button id='tag-toggle-focus' text='Set focus to toggle' />
  </div>`,
    js: `var tagButton = document.querySelector('#tag-toggle-focus');
  tagButton.componentOnReady().then(function() {
    tagButton.addEventListener('buttonClick', function(e) {
      var tagToggle = document.querySelector('tag-toggle');
      tagToggle.focusToggle();
    });
  });`,
  },
  coreComponent_v3: {
    html: `<tag3-toggle value='2'{{...knobs}}>
    <tag3-toggle-option value='1'>Option 1</tag3-toggle-option>
    <tag3-toggle-option value='2'>Option 2</tag3-toggle-option>
    <tag3-toggle-option value='3'>Option 3</tag3-toggle-option>
  </tag3-toggle>
  <div>
    <tag3-button id="tag3-toggle-focus">Set focus to toggle</tag3-button>
  </div>
  `,
    js: `var tag3Button = document.querySelector('#tag3-toggle-focus');
    tag3Button.addEventListener('buttonClick', function(e) {
      var tag3Toggle = document.querySelector('tag3-toggle');
      tag3Toggle.focusToggle();
    });`,
  },
  reactWrapper: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
    setTimeout(()=>{
      var tagButton = document.querySelector('#tag-toggle-focus');
      tagButton.componentOnReady().then(function() {
        tagButton.addEventListener('buttonClick', function(e) {
          var tagToggle = document.querySelector('tag-toggle');
          tagToggle.focusToggle();
        });
      });
    },500);
    return (
      <div>
        <TagToggle value='2'
        data={[
          { label: 'Option 1', value: 1 },
          { label: 'Option 2', value: 2 },
          { label: 'Option 3', value: 3 },
        ]}/>
        <div style={{marginTop: '10px'}}>
          <tag-button id='tag-toggle-focus' text='Set focus to toggle' />
        </div>
      </div>
    )
  };`,
  },
  reactWrapper_v3: {
    jsx: `<Example />`,
    parentJSX: `Example = () => {
  const coreComponent = React.useRef(null);
  return (
    <div>
      <Tag3Toggle ref={coreComponent} value='2'
      data={[
        { label: 'Option 1', value: 1 },
        { label: 'Option 2', value: 2 },
        { label: 'Option 3', value: 3 },
      ]}/>
      <div style={{marginTop: '10px'}}>
        <Tag3Button id='tag3-toggle-focus' text='Set focus to toggle' onButtonClick={() => coreComponent.current.focusToggle()} />
      </div>
    </div>
  )
};`,
  },
};

const setValue: Story = {
  title: 'Set Value',
  description: 'Manually set the value of the toggle using JS.',
  coreComponent: {
    html: `<tag-toggle value='2'{{...knobs}}>
  <tag-edit-field-option value='0'>Option 0</tag-edit-field-option>
  <tag-edit-field-option value='1'>Option 1</tag-edit-field-option>
  <tag-edit-field-option value='2'>Option 2</tag-edit-field-option>
  <tag-edit-field-option value='3'>Option 3</tag-edit-field-option>
</tag-toggle>
<div style='margin-top: 10px'>
  <tag-button id="setValue">Manually change toggle value to 3</tag-button>
</div>`,
    js: `var tagButton = document.querySelector('#setValue');
tagButton.componentOnReady().then(function() {
  tagButton.addEventListener('buttonClick', function(e) {
    var tagToggle = document.querySelector('tag-toggle');
    tagToggle.value = "3";
  });
});`,
    knobs: PlaygroundKnobs,
  },
  coreComponent_v3: {
    html: `<tag3-toggle value='2'{{...knobs}}>
  <tag3-toggle-option value='0'>Option 0</tag3-toggle-option>
  <tag3-toggle-option value='1'>Option 1</tag3-toggle-option>
  <tag3-toggle-option value='2'>Option 2</tag3-toggle-option>
  <tag3-toggle-option value='3'>Option 3</tag3-toggle-option>
</tag3-toggle>
<div style='margin-top: 10px'>
  <tag3-button id="setValue">Manually change toggle value to 3</tag3-button>
</div>`,
    js: `var tagButton = document.querySelector('#setValue');
tagButton.componentOnReady().then(function() {
  tagButton.addEventListener('buttonClick', function(e) {
    var tagToggle = document.querySelector('tag3-toggle');
    tagToggle.value = "3";
  });
});`,
    knobs: PlaygroundKnobsV3,
  },
};

export const TagToggleOption: Component = {
  type: 'component',
  name: 'toggle-option',
  description: `Defines an option in tag3-toggle. This is specified as a nested element within tag3-toggle.`,
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'name',
      type: 'string',
      description: 'The name of the toggle option',
    },
    {
      name: 'value',
      type: 'any',
      description: 'The value of the toggle option',
    },
    {
      name: 'disabled',
      type: 'boolean',
      description: 'Whether the option is disabled or not',
    },
  ],
  reactPropOverrides: [],
  events: [],
  methods: [],
  stories: [],
};

export const TagToggleDocs: Component = {
  type: 'component',
  name: 'toggle',
  description: 'Renders a toggle',
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'name',
      description: 'A unique name for the toggle',
      type: 'string',
    },
    {
      name: 'disabled',
      description: 'Whether the toggle is disabled or not',
      type: 'boolean',
    },
    {
      name: 'accent',
      description: 'The colour of the selected state',
      type: 'string',
    },
    {
      name: 'value',
      description: 'The selected option',
      type: 'any',
    },
    {
      name: 'data',
      description:
        'Any array of data that drives the toggle items (alternative to using nested tag-edit-field-option tags',
      type: 'string[] | {label: string, value: any}',
    },
    {
      name: 'textField',
      description: 'The field in the data array prop that gives the text to show in the component',
      type: 'string',
      default: 'label',
    },
    {
      name: 'valueField',
      description:
        'The field in the data array prop that gives the actual value put in the value prop',
      type: 'string',
      default: 'value',
    },
    {
      name: 'colour-scheme',
      description:
        'V3 Only: Dark mode (theme) control. Default for normal browser driven control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light | default',
      default: 'string',
    },
    {
      name: 'device',
      description: 'V3 Only: set preferred styling theme for device type.',
      type: 'desktop | mobile',
      default: 'desktop',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'valueChange',
      description: 'V1 only: Raised when the toggle selected item changes',
      parameters: [{ name: 'value', description: 'The selected value', type: 'any' }],
    },
    {
      name: 'toggleValueChange',
      description: 'V3 only: Raised when the toggle selected item changes',
      parameters: [
        { name: 'value', description: 'The selected value', type: 'any' },
        { name: 'name', description: 'The selected name', type: 'string' },
      ],
    },
  ],
  methods: [
    {
      name: 'focusToggle',
      description: 'Sets the focus to the toggle',
      parameters: [],
      returnType: 'void',
    },
  ],
  stories: [PlaygroundStory, DataStory, FocusStory, setValue],
  childComponents: [TagToggleOption],
};
